export default __webpack_public_path__ + "static/media/020_start.first.47e4897d.webp";